import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Polls /api/energy/live every `intervalMs` and returns { latest, history, loading, error }.
export function useLiveEnergy(personaKey, intervalMs = 3000) {
    const [latest, setLatest] = useState(null);
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const timerRef = useRef(null);
    const rollingRef = useRef([]);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);
        rollingRef.current = [];

        // Prime with 12h history for the sparkline
        axios
            .get(`${API}/energy/history`, { params: { persona: personaKey, hours: 12 } })
            .then((r) => {
                if (cancelled) return;
                setHistory(r.data);
                rollingRef.current = r.data.slice(-30);
            })
            .catch((e) => !cancelled && setError(e.message));

        const tick = async () => {
            try {
                const r = await axios.get(`${API}/energy/live`, { params: { persona: personaKey } });
                if (cancelled) return;
                setLatest(r.data);
                rollingRef.current = [...rollingRef.current, r.data].slice(-30);
                setHistory([...rollingRef.current]);
                setLoading(false);
            } catch (e) {
                if (!cancelled) setError(e.message);
            }
        };

        tick();
        timerRef.current = setInterval(tick, intervalMs);

        return () => {
            cancelled = true;
            clearInterval(timerRef.current);
        };
    }, [personaKey, intervalMs]);

    return { latest, history, loading, error };
}
